import { useRef, useEffect } from 'react';
import { useReactToPrint } from 'react-to-print';
import Events from '../../../../../utilities/EventEmitter';
import usePrintLoadingGuideData from './usePrintLoadingGuideData';
import LoadingGuideContainer from './components/Container';
import './print.scss';

const PrintLoadingGuide = ({
  userProfile,
  IBPlanningStore,
  columnConfig,
  getSelectedRoutes,
  enqueueSnackbar,
  configJSON,
}) => {
  const printRef = useRef(null);
  const { printData, fetchAndPrepareData, resetPrintData, printOrientation } = usePrintLoadingGuideData(
    IBPlanningStore,
    columnConfig,
    getSelectedRoutes,
    userProfile,
    enqueueSnackbar,
    configJSON
  );

  useEffect(() => {
    Events.on('PrintLoadingGuide', fetchAndPrepareData);
    return () => {
      Events.off('PrintLoadingGuide', fetchAndPrepareData);
    };
  }, [fetchAndPrepareData, handlePrintEvent]);

  useEffect(() => {
    if (printData.length > 0) {
      handlePrintEvent();
    }
  }, [printData]);

  const handlePrintEvent = useReactToPrint({
    content: () => printRef.current,
    copyStyles: true,
    onAfterPrint: () => resetPrintData(),
    pageStyle: `
      @page {
        size: A4 ${printOrientation.current} !important; //required to override the default orientation
      }
    `,
  });

  return printData ? <LoadingGuideContainer printRef={printRef} printData={printData} /> : null;
};

export default PrintLoadingGuide;
